<div class="product-info-container">
    <h2 class="product-info-title">{{productInfoTitle}}</h2>
    <p *ngIf="productInfoSection">{{productInfoSection}}</p>
</div>